import getMapData from './_getMapData';

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

export default mapCacheDelete;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_mapCacheDelete.js
// module id = 319
// module chunks = 0